export async function wait(ms: number = 0): Promise<any> {
    return new Promise((resolve, reject) => {
        setTimeout(resolve, ms);
    });
}